import { Text } from '@chakra-ui/react';
import { ErrorMessage } from 'formik';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';

interface Props {
  name: string;
}

const FieldErrorMessage: FC<Props> = ({ name }) => {
  return (
    <ErrorMessage
      name={name}
      render={(errorMessage: string) => (
        <Text mt="5px" color={Color.Error}>{errorMessage}</Text>
      )}
    />
  );
};

export default FieldErrorMessage;
